import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actions from "../actions";
import { isLoggedIn, login } from "../utils/AuthService";

import Nav from "../components/Navbar";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import Login from "../components/LoginForm";
import Logout from "../components/Logout";
import HomePage from "../components/HomePage";
import User from "../components/User";
import UserProfile from "../components/UserProfile";
import ManagePlaylistPage from "../components/ManagePlaylistsPage";
import PlaylistPage from "../components/PlaylistPage";

class Main extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Nav user={this.props.currentUser} />
          <div className="container">
            <Route
              exact={true}
              path="/"
              render={(props) => <HomePage login={login} />}
            />
            <Route path="/contact" component={Contact} />
            <Route path="/login" component={Login} />
            <Route
              path="/logout"
              render={(props) => (
                <Logout logout={this.props.actions.removeCurrentUser} />
              )}
            />
            <Route
              path="/user"
              exact={true}
              render={(props) => <User {...props} />}
            />
            <Route
              path="/user/profile"
              exact={true}
              render={() =>
                isLoggedIn() ? <UserProfile /> : <Redirect to="/" />
              }
            />
            <Route
              path="/playlists"
              exact={true}
              render={() =>
                isLoggedIn() ? <ManagePlaylistPage /> : <Redirect to="/" />
              }
            />
            <Route
              path="/playlists/:owner/:id"
              render={(props) =>
                isLoggedIn() ? <PlaylistPage {...props} /> : <Redirect to="/" />
              }
            />
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    appState: state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/Main.js